export const SELECT_DETAILS_OFFER = 'SELECT_DETAILS_OFFER';
export const SET_AUTO_LOAN_DETAILS_REFINANCE =
  'SET_AUTO_LOAN_DETAILS_REFINANCE';
export const SET_AUTO_LOAN_DETAILS_PURCHASE = 'SET_AUTO_LOAN_DETAILS_PURCHASE';
export const SELECT_AUTO_LOAN_OFFER_TAB = 'SELECT_AUTO_LOAN_OFFER_TAB';
